import {
  INTERVIEW_PLANNED_REQUEST, INTERVIEW_PLANNED_FAIL, INTERVIEW_PLANNED_SUCCESS
} from "../constants/AuthConstant";

const initialState = {
  loading: false,
  action: "Job Action",
  result: null,
  msg: "",
  error: "",
};

const InterviewPlannedReducer = (state = initialState, action) => {
  switch (action.type) {
    case INTERVIEW_PLANNED_REQUEST:
      return {
        ...state,
        loading: action.payload,
      };
    case INTERVIEW_PLANNED_SUCCESS:
      return {
        ...state,
        result: action.result.data,
        loading: action.payload,
        msg: action.msg,
      };
    case INTERVIEW_PLANNED_FAIL:
      return {
        ...state,
        error: action.error,
        loading: action.payload,
        msg: action.msg,
      };

    default:
      return state;
  }
};

export default InterviewPlannedReducer;
